import * as Sentry from '@sentry/react'
import { t } from 'i18next'
import { ErrorState } from './ErrorState'
import { Button } from './ui/button'

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <Sentry.ErrorBoundary fallback={({ error, componentStack, resetError }) => (
      // <div>
      //   <h2>{t('error.title')}</h2>
      //   <button onClick={resetError}>{t('error.tryAgain')}</button>
      // </div>
      <ErrorState>
        <h2>{t('error.title')}</h2>
        <Button variant="outline" onClick={resetError}>{t('error.tryAgain')}</Button>
      </ErrorState>
    )}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
